import { render, staticRenderFns } from "./IndivResults.vue?vue&type=template&id=3157a64c&scoped=true&"
import script from "./IndivResults.vue?vue&type=script&lang=ts&"
export * from "./IndivResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3157a64c",
  null
  
)

export default component.exports